import { IPixelCustomDataParameters } from '@faire/web-api--source/indigofair/data/IPixelCustomDataParameters';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'checkout-owf_purchase_placed-click';

/**
 * Handles purchase events when an order is submitted by a brand accepted into Open With Faire
 */
export function trackCheckoutOwfPurchasePlacedClick(
  pixelCustomDataParams?: IPixelCustomDataParameters
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    facebookPixelEvent: 'OwFPurchase',
    pixelCustomDataParams,
  });
}
